import React from 'react';
import Spinner from 'react-spinner';

import fetchContent from '../../helpers/backend-communication';
import CountryProfileMenu from './Menu';
import CountryProfileBody from './CountryProfileBody';

// Error boundary component to catch rendering errors
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.message };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h3>Something went wrong</h3>
          <p>An error occurred while loading this section.</p>
          <p><small>{this.state.errorMessage}</small></p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default class CountryProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: false,
      error: null,
    };
  }

  componentDidMount() {
    // Set mounted flag
    this._isMounted = true;

    console.log("Fetching content for country profile....", this.props.countryCode);

    // Set initial loading state
    this.setState({
      isLoading: true
    });

    // Use the fetchContent helper which should handle API URL prefixing
    fetchContent('countryprofile', `/${this.props.countryCode}`)
      .then(responseObject => {
        // Only update state if component is still mounted
        if (this._isMounted) {
          console.log("Country Profile API response:", responseObject);

          if (!responseObject) {
            throw new Error('No response data received');
          }

          // Handle the response correctly - either it already has sections or it is the sections
          const countryProfileData = responseObject.sections || responseObject;
          console.log("Country Profile parsed data:", countryProfileData);

          this.setState({
            data: Array.isArray(countryProfileData) ? countryProfileData : [],
            isLoading: false
          }, () => {
            console.log("State after update:", this.state);
          });
        }
      })
      .catch(error => {
        // Only update state if component is still mounted
        if (this._isMounted) {
          console.error('Fetch of country profile went wrong', error);

          this.setState({
            data: [],
            isLoading: false,
            error: error.message || 'Error loading country profile'
          });
        }
      });
  }

  componentWillUnmount() {
    // Clear mounted flag to prevent memory leaks
    console.log('Clearing mounted flag on unmount');
    this._isMounted = false;
  }

  render() {
    const { data, isLoading, error } = this.state;

    const firstSectionData = data && Array.isArray(data) && data.length > 0 ? data[0] : null;
    const subSections = firstSectionData && firstSectionData.sub_sections ? firstSectionData.sub_sections : null;

    return (
      <div>
        <h2 className="title">Implementation status of the Programme of Action</h2>

        <div className="country-profile-header">
          <h1 className="country-profile-title background-country-flag title">
            { this.props.countryName }
          </h1>

          <ErrorBoundary>
            <CountryProfileMenu
              countryName={ this.props.countryName }
              countryCode={ this.props.countryCode }
              npcData={ subSections }
            />
          </ErrorBoundary>
        </div>

        <ErrorBoundary>
          <CountryProfileBody data={data} isLoading={isLoading} error={error} />
        </ErrorBoundary>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfile.js